export const TOKEN_REFRESH_FAILED = "TOKEN_REFRESH_FAILED";
